import {
  YoutubeLogo,
  FacebookLogo,
  LinkedinLogo,
  WhatsappLogo,
  Envelope,
  TiktokLogo,
} from "@phosphor-icons/react";
const SocialMedia = () => {
  return (
    <div className="hidden lg:flex text-white  flex-col justify-center items-end gap-3  group  absolute right-0 top-1/2 -translate-y-1/2">
      <a
        target="_blank"
        rel="noreferrer"
        href="https://wa.me/+97143468556"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <WhatsappLogo />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.youtube.com/channel/UCkLYcWRXEm2W-5QZa1pVDPw"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <YoutubeLogo />
      </a>
      <a
        href="https://www.facebook.com/MartinProfessionalMiddleEast/"
        target="_blank"
        rel="noreferrer"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <FacebookLogo />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/company/martin-professional-middle-east/"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <LinkedinLogo />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.tiktok.com/@martinprofessional.me?is_from_webapp=1&sender_device=pc"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <TiktokLogo />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="mailto:sales@martinpro-me.com"
        className="bg-black opacity-[0.5] w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center"
      >
        <Envelope />
      </a>
      {/* <span className="bg-gray-600 w-8 h-8 p-1 rounded-full p-1 text-xl flex items-center justify-center">
        <InstagramLogo />
      </span> */}

      <button className="w-1/4 mt-4 relative z-[100] ml-auto h-[4px] bg-white"></button>

      <span
        className={`mt-14 min-w-full hidden md:flex items-end justify-end w-full transition ease-in duration-300 opacity-0 translate-y-[-100%] group-hover:opacity-100 group-hover:translate-y-[0]
         `}
      >
        <p className="uppercase text-lg leading-loose font-light text-end translate-x-12 rotate-[-90deg]">
          Stay connected
        </p>
      </span>
    </div>
  );
};

export default SocialMedia;
